import React, { useState } from "react";
import { Pie } from "react-chartjs-2";
import { Link } from "react-router-dom";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Helmet } from "react-helmet";

ChartJS.register(ArcElement, Tooltip, Legend);

const KotakSipCalculator = ({ isSip, setIsSip }) => {
  const [monthlyInvestment, setMonthlyInvestment] = useState(25000);
  const [expectedReturnRate, setExpectedReturnRate] = useState(12);
  const [timePeriod, setTimePeriod] = useState(10);

  const calculateSIP = () => {
    const monthlyRate = expectedReturnRate / 100 / 12;
    const months = timePeriod * 12;
    const investedAmount = monthlyInvestment * months;
    const futureValue =
      monthlyInvestment *
      ((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate) *
      (1 + monthlyRate);
    const estimatedReturns = futureValue - investedAmount;

    return {
      investedAmount,
      estimatedReturns,
      totalValue: futureValue,
    };
  };

  const { investedAmount, estimatedReturns, totalValue } = calculateSIP();

  const data = {
    labels: ["Invested Amount", "Estimated Returns"],
    datasets: [
      {
        label: "SIP Returns Breakdown",
        data: [investedAmount, estimatedReturns],
        backgroundColor: ["#36A2EB", "#FF6384"],
      },
    ],
  };
  function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is the Kotak Mutual Fund SIP Calculator?",
            "answer": "It is a digital tool that estimates the future maturity value of your SIP investments in Kotak mutual funds."
          },
          {
            "question": "Is it free to use?",
            "answer": "Yes, it’s completely free and accessible to anyone planning SIP investments."
          },
          {
            "question": "What’s the minimum SIP amount I can start with?",
            "answer": "You can start investing in Kotak SIPs with as little as ₹500 per month."
          },
          {
            "question": "Can the calculator help with goal-based planning?",
            "answer": "Yes, simply enter your desired corpus and the tenure to get the recommended SIP amount."
          },
          {
            "question": "Are the results accurate?",
            "answer": "Results are projections based on your inputs. Actual results may vary based on market conditions."
          },
          {
            "question": "Can I adjust the return rate?",
            "answer": "Yes, the calculator lets you input custom expected return rates (e.g., 8%, 10%, 12%)."
          },
          {
            "question": "Are SIP returns taxed?",
            "answer": "Yes. Equity gains above ₹1 lakh are taxed at 10% (LTCG), and debt fund gains are taxed as per your income slab (post indexation if long-term)."
          },
          {
            "question": "Can the calculator be used for non-Kotak funds?",
            "answer": "Mathematically, yes. But for fund-specific insights, use the official Kotak or TheFinmaster calculator."
          },
          {
            "question": "How often should I review my SIP?",
            "answer": "Ideally, every 6–12 months or after major life events or market shifts."
          },
          {
            "question": "Can I increase my SIP amount mid-way?",
            "answer": "Yes, many Kotak funds allow SIP top-ups (also known as step-up SIPs)."
          },
          {
            "question": "Does the calculator account for inflation?",
            "answer": "Not directly, but you can adjust your expected return rate or goal amount accordingly."
          },
          {
            "question": "What’s better—monthly SIP or quarterly SIP?",
            "answer": "Monthly SIPs offer smoother cost averaging and better market capture."
          },
          {
            "question": "Is there a mobile version of the calculator?",
            "answer": "Yes, both Kotak and TheFinmaster offer responsive mobile interfaces."
          },
          {
            "question": "Can I save or share my SIP plan?",
            "answer": "Yes, use the download or share options on the page to keep a record or send it to your advisor."
          }
        ]
    
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
      <Helmet>
        <title>
          Kotak SIP Calculator- Calculate Returns on Kotak SIP Investments | TheFinmaster
        </title>
        {/* <meta
          name="description"
          content="Free SIP Calculator! Estimate your returns on Mutual Fund investments with Systematic Investment Plans."
        />
        <meta
          name="keywords"
          content="sip return rate, monthly sip calculator, step up sip, sip calculator online"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/financial-tools-calculators/sip-calculator"
        /> */}
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>

      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">
              Home
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>
          <li className="flex items-center">
            <Link
              to="/financial-tools-calculators"
              className="text-blue-600 hover:text-blue-800"
            >
              Financial Tools Calculators
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>
          <li className="flex items-center">
            <span className="text-gray-500 "> Kotak SIP Calculator</span>
          </li>
        </ol>
        
      </nav>
      <div className="py-6">
        <div className="container mx-auto p-4 shadow-xl rounded-md ">
          
          <h1 className="text-2xl font-bold mb-4">Kotak SIP Returns Calculator</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div>
              <div className="mb-4">
                <label className="block text-gray-700 font-semibold">
                  Monthly Investment
                </label>
                <div className="flex items-center">
                  <input
                    type="number"
                    min="0"
                    max="100000"
                    value={monthlyInvestment}
                    onChange={(e) =>
                      setMonthlyInvestment(Number(e.target.value))
                    }
                    className="w-1/2 p-2 border rounded mr-2"
                  />
                  <span className="text-gray-700">
                    ₹ {monthlyInvestment.toLocaleString()}
                  </span>
                </div>
                <input
                  type="range"
                  min="0"
                  max="100000"
                  value={monthlyInvestment}
                  onChange={(e) => setMonthlyInvestment(Number(e.target.value))}
                  className="w-full mt-2"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 font-semibold">
                  Expected Return Rate (P.A.)
                </label>
                <div className="flex items-center">
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.1"
                    value={expectedReturnRate}
                    onChange={(e) =>
                      setExpectedReturnRate(Number(e.target.value))
                    }
                    className="w-1/2 p-2 border rounded mr-2"
                  />
                  <span className="text-gray-700">{expectedReturnRate} %</span>
                </div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  step="0.1"
                  value={expectedReturnRate}
                  onChange={(e) =>
                    setExpectedReturnRate(Number(e.target.value))
                  }
                  className="w-full mt-2"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 font-semibold">
                  Time Period (Years)
                </label>
                <div className="flex items-center">
                  <input
                    type="number"
                    min="1"
                    max="50"
                    value={timePeriod}
                    onChange={(e) => setTimePeriod(Number(e.target.value))}
                    className="w-1/2 p-2 border rounded mr-2"
                  />
                  <span className="text-gray-700">{timePeriod} Yr</span>
                </div>
                <input
                  type="range"
                  min="1"
                  max="50"
                  value={timePeriod}
                  onChange={(e) => setTimePeriod(Number(e.target.value))}
                  className="w-full mt-2"
                />
              </div>
              <button
                onClick={calculateSIP}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                Calculate
              </button>
            </div>
            <div>
              <div className="mb-4">
                <h2 className="text-xl font-bold">Results</h2>
                <p>Invested Amount: ₹ {investedAmount.toLocaleString()}</p>
                <p>Estimated Returns: ₹ {estimatedReturns.toLocaleString()}</p>
                <p>Total Value: ₹ {totalValue.toLocaleString()}</p>
              </div>
              <div>
                <h2 className="text-xl font-bold">Breakdown</h2>
                <div className="flex justify-center">
                  <Pie
                    data={data}
                    options={{ maintainAspectRatio: false }}
                    width={300}
                    height={300}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6">
      <div className="w-full md:w-2/3 p-4 mx-auto">
      <div className="container mx-auto py-4">
          <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Kotak Mutual Fund SIP Calculator
          </h1>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Systematic Investment Plans (SIPs) have revolutionized how retail investors approach mutual fund investing in India. With its legacy of trust and innovation in the financial space, Kotak Mahindra Asset Management Company has made mutual fund investing accessible to millions. The Kotak Mutual Fund SIP Calculator is an essential online tool that allows investors to estimate the future value of their SIP contributions and make well-informed financial decisions.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            This page provides a deep dive into what SIPs are, how Kotak’s calculator works, key advantages, and how it aligns with your long-term financial goals—whether it's wealth accumulation, retirement, children’s education, or tax planning.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is SIP and Why Should You Invest via SIPs?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Systematic Investment Plan (SIP) is a methodical way of investing in mutual funds, where a fixed amount is debited from your bank account at regular intervals (monthly, quarterly, etc.) and invested in your chosen Kotak mutual fund scheme. This disciplined approach removes the emotional decision-making and volatility associated with lump-sum investing.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Why SIPs Make Sense:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Rupee Cost Averaging:</strong> By buying units at different market levels, you average your purchase cost over time, reducing the risk of market timing.</li>
              <li><strong>Power of Compounding:</strong> The longer you stay invested, the more your returns compound on previous gains, leading to exponential growth.</li>
              <li><strong>Affordability:</strong> Start with as low as ₹500 per month, making it accessible for everyone, from students to salaried professionals.</li>
              <li><strong>Flexibility:</strong> You can modify, pause, or stop your SIP based on life stage or financial conditions.</li>
              <li><strong>Goal-Based Investing:</strong> SIPs can be mapped to specific life goals—house purchase, child’s future, vacations, or retirement.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Kotak Mutual Fund offers diverse schemes across equity, hybrid, debt, and ELSS categories. Each fund caters to different risk appetites and investment durations, making it easier to align with your financial goals.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Kotak SIP Calculator and How Does it Help?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Kotak SIP Calculator is an intelligent financial planning tool that allows you to:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Estimate how much wealth your SIP can generate over time</li>
              <li>Determine the monthly investment required to reach a future financial goal</li>
              <li>Simulate different scenarios by adjusting return rates and durations</li>
              <li>Plan smarter by seeing the exact split between your invested capital and earned returns</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This calculator bridges the gap between intent and execution. It transforms abstract financial goals into tangible figures and timelines. For example, if your goal is to create ₹25 lakhs in the next 15 years, the calculator helps you work backwards to find the ideal SIP amount needed today.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Key Benefits of the Kotak SIP Calculator
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Kotak SIP Calculator is not just a numbers tool—it’s a goal visualization engine. Here’s why it's indispensable for every investor:
            </p>
            <ol className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Clarity in Goal Planning</strong><br />
                Rather than relying on guesswork, the calculator gives exact figures on how your investments will grow, empowering you to set realistic expectations for future returns.</li>
              <li><strong>Instant Output</strong><br />
                No manual math. The results are delivered in real-time, helping you compare multiple scenarios in seconds.</li>
              <li><strong>Visual Growth Charts</strong><br />
                The tool presents a visual breakdown showing:<br />
                Total Investment<br />
                Total Returns Earned<br />
                Final Maturity Value<br />
                This snapshot lets you instantly see how even small monthly contributions can lead to substantial future wealth.</li>
              <li><strong>Helps in Budgeting</strong><br />
                If you're planning a goal-based SIP (e.g., ₹10 lakhs in 10 years), the calculator shows how much you need to invest monthly to achieve it without disrupting your lifestyle.</li>
              <li><strong>Market-Adjusted Planning</strong><br />
                Since SIP returns depend on market performance, the calculator allows you to adjust expected return rates. This helps simulate bull, bear, and average-case scenarios.</li>
              <li><strong>Flexibility Across Goals</strong><br />
                Whether you're saving for your child’s education or planning a down payment for a home, the calculator adapts to every goal size and tenure.</li>
            </ol>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Kotak SIP Calculator Work?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The tool uses the following standard compound interest formula to compute SIP returns:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Formula:</strong><br />
              M = P × [(1 + i)<sup>n</sup> - 1] / i × (1 + i)
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>M = Maturity amount</li>
              <li>P = SIP amount per month</li>
              <li>i = Monthly rate of return = (Annual Return ÷ 12)</li>
              <li>n = Number of months (Investment tenure)</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Sample Calculation:</strong><br />
              Let’s say you invest ₹4,000 per month for 10 years at an expected annual return of 12%:<br />
              Monthly rate (i) = 1%<br />
              Tenure (n) = 120 months<br />
              Total Investment = ₹4,000 × 120 = ₹4,80,000<br />
              Maturity Value (M) ≈ ₹9,26,000<br />
              Here, ₹4.8 lakh invested over 10 years nearly doubles due to the power of compounding and market-driven returns.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How to Use the Kotak Mutual Fund SIP Calculator (Step-by-Step)
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using the calculator is easy and intuitive. Follow these steps:
            </p>
            <ol className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Enter Monthly Investment Amount – Example: ₹5,000</li>
              <li>Set the Expected Rate of Return – Typically between 10-14% for equity funds</li>
              <li>Select the Investment Duration – 1 to 30+ years</li>
              <li>View Results Instantly – Including total investment, returns earned, and final corpus</li>
              <li>Switch Modes (Optional) – Choose between:<br />
                <ul className="list-disc pl-6 mt-2">
                  <li>Regular SIP Mode – for general wealth accumulation</li>
                  <li>Goal-Based SIP Mode – for planning towards specific corpus goals</li>
                </ul>
              </li>
            </ol>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              You can run multiple simulations by adjusting variables to find the perfect SIP plan.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster SIP Calculator for Kotak Mutual Fund?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The SIP calculator on TheFinMaster is designed with a sharp focus on usability and depth:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Clean UI & UX:</strong> Minimal design with sliders and visual aids</li>
              <li><strong>Detailed Results:</strong> Clearly splits investment vs. growth</li>
              <li><strong>Goal-Based Flexibility:</strong> Plan SIPs based on your future corpus goal</li>
              <li><strong>Risk Awareness:</strong> Links to risk disclaimers and fund volatility insights</li>
              <li><strong>Educational Add-ons:</strong> Learn about SIPs, mutual fund categories, taxation, and investment strategies</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Influencing Kotak SIP Returns
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Understanding the variables that affect your SIP growth helps in creating better strategies:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Monthly Investment Amount –</strong> Larger contributions yield higher returns over time.</li>
              <li><strong>Investment Tenure –</strong> Longer durations amplify the power of compounding.</li>
              <li><strong>Type of Fund Chosen –</strong> Equity funds tend to offer higher returns but with more risk. Debt funds offer more stability with moderate growth.</li>
              <li><strong>Market Conditions –</strong> Economic cycles affect returns. SIPs mitigate this risk via rupee cost averaging.</li>
              <li><strong>Return Assumption Accuracy –</strong> Being conservative with return expectations (10–12%) is advisable.</li>
              <li><strong>Inflation Adjustment –</strong> The real value of your corpus should be inflation-adjusted.</li>
              <li><strong>Taxation Rules –</strong> ELSS schemes offer tax benefits under 80C, while equity funds face LTCG (above ₹1 lakh taxed at 10%).</li>
            </ul>
          </div>
        </div>

        <div className="w-full md:w-1/3 p-4">
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
              <h2 className="text-lg font-semibold ">Popular Categories</h2>
            </div>
            <div className="p-2 ">
              <ul>
                <Link to="/financial-tools-calculators/swp-calculator">
                  <li className="py-2  hover:bg-slate-100 border-b border-gray-300">
                    SWP Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/mutul-fund-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Mutual Fund Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/sukanya-samriddhi-yojana-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Samriddhi Yojana Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/fd-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    FD Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/rd-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    RD Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/nps-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    NPS Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/hra-exemption-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    HRA Exemption Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/retirement-planning-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Retirement Planning Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/emi-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    EMI Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/simple-interest-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Simple Interest Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/compound-interest-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Compound Interest Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/nsc-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    NSC Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/step-up-sip-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Step Up Sip Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/income-tax-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Income Tax Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/home-loan-emi-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Home Loan Emi Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/car-loan-emi-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Car Loan Emi Calculator
                  </li>
                </Link>
                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
              </ul>
            </div>
          </div>
          <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
            <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
              <h2 className="text-lg font-semibold">More Categories</h2>
            </div>
            <div className="p-2">
              <ul>
                <Link to="/financial-tools-calculators/gratuity-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Gratuity Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/APY-calculator">
                  <li className="py-2 border- hover:bg-slate-100 border-gray-300">
                    APY Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/cagr-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    CAGR Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/gst-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    GST Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/flat-vs-reducing-rate-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Flat Vs Reducing Rate Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/equity-margin-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Equity Margin Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/inflation-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Inflation Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/salary-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Salary Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/brokerage-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    Brokerage Calculator
                  </li>
                </Link>
                <Link to="/financial-tools-calculators/tds-calculator">
                  <li className="py-2 border-b hover:bg-slate-100 border-gray-300">
                    TDS Calculator
                  </li>
                </Link>
                {/* {moreCategories.map(category => (
          <Link key={category.id} to={`/category/${category.id}`}>
            <li className="py-2 border-b border-gray-300">{category.name}</li>
          </Link>
        ))} */}
              </ul>
            </div>
          </div>
        </div>
      </div>
             {/* FAQ section */}
    <div className="max-w-4xl mx-auto py-6 mt-10 px-2">
                <h1 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
    </>
  );
};

export default KotakSipCalculator;
